import React from 'react';
import './About.css';

export const About: React.FC = () => {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        <div className="about-content">
          <h2 className="about-title">Sobre o Opsight</h2>
          <p className="about-description">
            Opsight nasceu da necessidade de transformar dados de desenvolvimento de software em insights acionáveis. 
            Acreditamos que métricas bem apresentadas podem melhorar significativamente a qualidade 
            e velocidade do desenvolvimento de software.
          </p>
          <p className="about-description">
            Nossa missão é fornecer ferramentas que ajudem times de engenharia a tomar decisões 
            baseadas em dados, identificar gargalos e melhorar continuamente seus processos.
          </p>
        </div>
      </div>
    </section>
  );
};









